export default {
  title: 'Подтвердите Ваше действие',
  description: 'Пожалуйста, подтвердите действие <b>{name}</b> введя код из Google Auth app.',
  confirmation: 'Введите код подтверждения',
  confirmation_placeholder: 'XXXXXX',
  btn_submit: 'Подтвердить',
}
